import React, { useState, useEffect } from "react";
import {Card, Tabs, Typography, theme} from "antd";
import {useAuth} from "../../hooks/useAuth";
import { useLocation } from 'react-router-dom';
import { UserOutlined, BellOutlined, CrownOutlined, SafetyOutlined } from "@ant-design/icons";
import MyProfile from "../../components/Profile/MyProfile";
import Notifications from "../../components/Profile/Notifications";
import { TwoFactorSettingsAnt } from "../../components/Auth/TwoFactorSettingsAnt";

const { Title } = Typography;

export const AdminProfile: React.FC = () => {
    const { user } = useAuth();
    const location = useLocation();
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const [activeTab, setActiveTab] = useState('profile');

    // Check for tab parameter in URL and set active tab
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const tabParam = searchParams.get('tab');
        if (tabParam && ['profile', 'security', 'notifications'].includes(tabParam)) {
            setActiveTab(tabParam);
        }
    }, [location.search]);

    const tabItems = [
        {
            key: 'profile',
            label: (
                <span>
                    <UserOutlined />
                    My Profile
                </span>
            ),
            children: <MyProfile />
        },
        {
            key: 'security',
            label: (
                <span>
                    <SafetyOutlined />
                    Security
                </span>
            ),
            children: <TwoFactorSettingsAnt />
        },
        {
            key: 'notifications',
            label: (
                <span>
                    <BellOutlined />
                    Notifications
                </span>
            ),
            children: <Notifications />
        }
    ];

    return (
        <div style={{ padding: '24px' }}>
            <div style={{ marginBottom: '24px' }}>
                <Title level={2} style={{ margin: 0, display: 'flex', alignItems: 'center' }}>
                    <CrownOutlined style={{ marginRight: '8px', color: '#722ed1' }} />
                    Admin Profile
                </Title>
            </div>
            
            <Card
                style={{
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                }}
            >
                <Tabs
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    items={tabItems}
                    size="large"
                />
            </Card>
        </div>
    );
};